import {Suspense} from 'react';
import {Outlet, createRoute, redirect} from '@tanstack/react-router';
import NotFoundPage from '@/anonymous/views/error/NotFoundPage';
import PatientLayout from '@/patient/components/layout/PatientLayout';
import RouteElementSkeleton from '@/shared/components/ui/skeletons/RouteElementSkeleton';
import {AppRouterContext} from '@/shared/routing';
import handleRedirectCookie from '@/shared/routing/handleRedirectCookie';
import {USER_HOME} from '@/shared/routing/paths';
import {Route as rootRoute} from '../__root';

function PatientRoutesLayoutComponent() {
  return (
    <PatientLayout>
      <Suspense fallback={<RouteElementSkeleton />}>
        <Outlet />
      </Suspense>
    </PatientLayout>
  );
}

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/u',
  component: PatientRoutesLayoutComponent,
  errorComponent: NotFoundPage,
  beforeLoad: function ({
    context,
    location: {pathname}
  }: {
    context: AppRouterContext;
    location: {pathname: string};
  }) {
    handleRedirectCookie({pathname, isLoggedIn: context.isLoggedIn});
    if (pathname === '/u') {
      throw redirect({to: USER_HOME, replace: true});
    }
  }
});
